// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"a19b3236","443":"12792668","453":"a7e10855","929":"5d5d6724"}[chunkId] + ".chunk.js";
};